
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return require("private-next-pages/home/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home"])
      });
    }
  